"use strict";

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQuery = parseQuery;
exports.getCookieOptions = getCookieOptions;
exports.mergeProps = mergeProps;
exports.getCopyright = getCopyright;
exports.getBackground = exports.getColor = void 0;

function parseQuery(str) {
  return str.slice(1).split('&').map(function (x) {
    return x.split('=');
  }).reduce(function (memo, x) {
    var key = x[0];
    var value = decodeURIComponent(x[1]) || true;
    memo[key] = value;
    return memo;
  }, {});
}

function getCookieOptions() {
  var expireInDays = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 365;
  var options = {
    expires: expireInDays,
    path: '/',
    domain: ''
  };

  if (typeof window === 'undefined') {
    return options;
  }

  var host = window.location.host; // eslint-disable-line

  var parts = host.split('.');

  if (parts.length === 1) {
    options.domain = '';
  } else {
    // Remember the cookie on all sub domains.
    while (parts.length > 2) {
      parts.shift();
    }

    options.domain = ".".concat(parts.join('.'));
  }

  return options;
}

var getColor = function getColor(props) {
  if (props.color) {
    return props.color;
  }

  if (props.dark) {
    return props.theme.palette.text.contrast;
  }

  return props.theme.palette.text.primary;
};

exports.getColor = getColor;

var getBackground = function getBackground(props) {
  if (props.background) {
    return props.background;
  }

  if (props.dark) {
    return props.theme.palette.text.primary;
  }

  return props.theme.palette.text.contrast;
};

exports.getBackground = getBackground;

function mergeProps(props, component) {
  var jsonAttrs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var newProps = Object.assign({}, props);
  Object.keys(component.defaultProps || {}).forEach(function (x) {
    if (typeof newProps[x] === 'string' && newProps[x].indexOf('::prop::') === 0) {
      // eslint-disable-next-line react/default-props-match-prop-types
      newProps[x] = component.defaultProps[x];
    }
  });

  if (Array.isArray(jsonAttrs)) {
    jsonAttrs.forEach(function (x) {
      if (typeof newProps[x] === 'string') {
        try {
          newProps[x] = JSON.parse(newProps[x]);
        } catch (err) {// Do nothing
        }
      }
    });
  }

  Object.keys(newProps).forEach(function (x) {
    if (typeof newProps[x] === 'string' && newProps[x].indexOf('::prop::') === 0) {
      newProps[x] = '';
    }
  });
  return newProps;
}

function getCopyright() {
  var startYear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2017;
  var currentYear = new Date().getFullYear();
  return "".concat(currentYear) === "".concat(startYear) ? "\xA9 ArcBlock ".concat(currentYear) : "\xA9 ArcBlock ".concat(startYear, " - ").concat(currentYear);
}